<template>
    <Carousel class="banner" :style="{height}" autoplay effect="fade" :speed="speed">
        <div class="item" :style="{height}" v-for="(item,index) in list" :key="index">
            <a v-link="item.link" :style="{backgroundImage :`url(${item.image})`}" v-if="item.link"> </a>
            <a href="javascript:;" :style="{backgroundImage :`url(${item.image})`}" v-else> </a>
        </div>
    </Carousel>
</template>

<script>
import {Carousel} from 'ant-design-vue'
export default {
    props:{
        list:{
            type:Array,
            default(){
                return []
            }
        },
        height: {
            type: String,
        }
    },
    data(){
        return {
            speed:5000
        }
    },
    components:{
        Carousel
    }
}
</script>
<style lang="scss" scoped>
.banner {
    height: 721px;
    .item {
        height:721px;
        overflow: hidden;
        a {
            display: block;
            height: 100%;
            background-size: cover!important;
            background-repeat: no-repeat;
            background-position: 50%;
        }
    }
    img {
        width: 100%;
        height: 100%;
    }
}
</style>


